import React, { useEffect, useRef, useState } from "react";
import "./KbList.css";
import SearchBar from "../SearchBar/SearchBar";
import { useLocation } from "react-router";
import { useSelector } from "react-redux";
import {
  Box,
  Collapse,
  useTheme,
} from "@mui/material";
import { Link } from "react-router-dom";
import {
  getAiGeneratedDataURL,
  getNextThinkDeviceDetailsURL,
} from "../../utils/constants";
import BackButton from "../../../../../application/commons/back-button/back-button";
import CustomTabs from "../CustomTabs/CustomTabs";
import { appConfig } from "../../../../../utils/app.config";
import NextThinkDevicesPopUp from "../Popups/NextThinkDevicesPopUP/NextThinkDevicesPopUp";
import { useDispatch } from "react-redux";
import { addKeyValuePair } from "../../../../../utils/redux-store/slices/searchSlice";
import Feedback from "../Popups/Feedback/Feedback";
import FeedbackGreet from "../Popups/FeedbackGreet/FeedbackGreet";


interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}



const KbList: React.FC = () => {
  const location = useLocation();
  const [value, setValue] = useState(0);
  const [searched, setSearched] = useState("");
  const [searchKB, setSearchKB] = useState([]);
  const [generatedData, setGeneratedData] = useState<any>([]);
  const [fixNow, setFixNow] = useState<string | null>(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const theme = useTheme();
  const [progress, setProgress] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [nextThinkResult, setNextThinkResult] = useState([]);
  const [multipleDevices, setMultipleDevices] = useState([]);
  const dispatch = useDispatch();
  const keyValueStore = useSelector((state: any) => state.search.keyValueStore)

  const [feedbackModal, setFeedbackModal] = useState(false);   
  const [feedbackGreet, setFeedbackGreet] = useState(false);

  const { passedData } = location.state || {};
  const storedPassedData = useRef("");

  if (passedData && passedData.length != 0) {
    storedPassedData.current = passedData;
  }

  useEffect(() => {
    setSearched(storedPassedData.current);
    setIsLoading(true);
    setGeneratedData([]);
    setProgress(0);
    storedPassedData.current.length > 0 &&
      getAiGeneratedData(storedPassedData.current);
  }, [storedPassedData.current]);

  useEffect(() => {
    let interval: any;

    if (isLoading) {
      interval = setInterval(() => {
        setProgress((prev) => (prev >= 99 ? 99 : prev + 1));
      }, 100);
    } else {
      clearInterval(interval);
      setProgress(100);
    }

    return () => clearInterval(interval);
  }, [isLoading]);

  const getAiGeneratedData = async (data: any) => {
    const result = keyValueStore[data];
    if (result) {
      if (result.nextthink !== null) {
        setFixNow(result.nextthink);
      }
      else {
        setFixNow(null);

      }
      setGeneratedData(result.answer);
      setIsLoading(false);
    } else {
      try {
        const options = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            query: data,
          }),
        };
        const result = await (await fetch(getAiGeneratedDataURL, options)).json();
        if (result) {
          if (result?.answer) {
            dispatch(addKeyValuePair({ key: data, value: result }));
            if (result.nextthink !== null) {
              setFixNow(result.nextthink);
            }
            else {
              setFixNow(null);

            }
            setGeneratedData(result.answer);
          }
          else {
            setGeneratedData(result?.ans);
          }
        }
      } catch (err: any) {
        console.log("ERROR :::", err);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleFeedback = () => {
    setFeedbackModal(!feedbackModal);
  }

  const handleGoodFeedback = () => {
    console.log("Like");
    setFeedbackGreet(!feedbackGreet);
  }

  const triggerScript = async (script_name: any) => {
    setModalOpen(true);
    console.log("SCRIPT NAME:::",script_name)
    try {
      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: "mfdmroot@CDD-Nexthink-Wi",
          script: script_name,
        }),
      };
      const result = await (
        await fetch(getNextThinkDeviceDetailsURL, options)
      ).json();
      if (result) {
        // const customResult: any = [
        //   {
        //     message:
        //       "Multiple devices found. Please select one to apply the auto-fix.",
        //     devices: ["ajdawijdiajdiajwda", "ahduwhdiahwduhawudha"],
        //   },
        // ];

       
        // setModalOpen(!modalOpen);
        setNextThinkResult(result);
        // setMultipleDevices(customResult);
      
        // if (
        //   result["message"] ==
        //   "Multiple devices found. Please select one to apply the auto-fix."
        // ) {
       

        // }


        console.log('next think result', result)
      }
    } catch (err: any) {
      console.log("ERROR :::", err);
    }
  };

  

  const tabData = [
    {
      name: "All",
      content: (
        <div
          style={{
            height: "calc(100vh - 172px)",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            overflowY: "auto",
          }}
        >
          <p className="about-heading">About: {storedPassedData.current}</p>
          {generatedData.length > 0 ? (
            <>
              {typeof generatedData === "string" ? (
                <>
                  <Box
                    style={{
                      padding: 16,
                      background: "rgb(255 221 232 / 29%)",
                      borderRadius: "8px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    <Collapse in={isExpanded} collapsedSize="198px">
                      <Box
                        sx={{
                          maxHeight: isExpanded ? "none" : "198px",
                          overflow: "hidden",
                          display: "flex",
                          gap: "8px",
                          flexDirection: "column",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            gap: "8px",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              gap: "8px",
                              alignItems: "center",
                            }}
                          >
                            <i
                              style={{ fontSize: "1.25rem", color: "#f98729" }}
                              className="bi bi-stars"
                            ></i>
                            <h5 className="h5-heading" style={{ margin: 0 }}>
                              AI Overview
                            </h5>
                          </div>

                          {fixNow && (
                            <button
                              className="btn btn-primary"
                              onClick={() => triggerScript(fixNow)}
                              style={{
                                width: "fit-content",
                                background: "rgb(240 72 112)",
                                border: "none",
                                borderRadius: "50px",
                                fontWeight: 600,
                              }}
                            >
                              Fix Now
                            </button>
                          )}
                        </div>
                        {modalOpen && (
                          <NextThinkDevicesPopUp
                            modalOpen={modalOpen}
                            setModalOpen={setModalOpen}
                            NextThinkData={nextThinkResult}
                          />
                        )}
                        <div
                          style={{
                            minHeight: "70px",
                            maxHeight: "fit-content",
                          }}
                        >
                          <div style={{ margin: 0 }}>
                            {/* <div
                              style={{
                                display: "flex",
                                gap: "10px",
                                marginBottom: "8px",
                              }}
                            >
                              <p style={{ margin: 0, fontWeight: 600 }}>
                                {storedPassedData.current}
                              </p>
                            </div> */}
                            <div style={{ whiteSpace: "pre-line" }}>
                              {formatText(generatedData)}
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                flexDirection: "column",
                                marginTop: "20px",
                                padding: "16px",
                                borderTop: "1px solid lightgrey",
                                gap: "6px",
                              }}
                            >
                              <p
                                style={{
                                  margin: 0,
                                  fontSize: "12px",
                                  fontWeight: 300,
                                }}
                              >
                                Provide your feedback
                              </p>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  gap: "10px",
                                }}
                              >
                                <div className="feedback-icn">
                                  <i className="bi bi-hand-thumbs-up" onClick={() => handleGoodFeedback()} ></i>
                                </div>
                                <div className="feedback-icn">
                                  <i  className="bi bi-hand-thumbs-down" onClick={() => handleFeedback()}></i>
                                </div>
                              </div>
                            </div>

                            {feedbackModal && (
                                  <Feedback
                                  feedbackModal = {feedbackModal}
                                  setFeedbackModal = {setFeedbackModal}
                                  feedbackGreet = {feedbackGreet}
                                  setFeedbackGreet = {setFeedbackGreet}
                                  />
                            )}

                            {feedbackGreet && (
                                  <FeedbackGreet
                                  feedbackGreet = {feedbackGreet}
                                  setFeedbackGreet = {setFeedbackGreet}
                                  />
                            )}

              
                          </div>
                        </div>
                      </Box>
                    </Collapse>

                    <button
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "fit-content",
                        borderRadius: "50px",
                        marginTop: "8px",
                        border: "1px solid #f04870",
                        color: "#f04870",
                      }}
                      className="btn btn-outline-secondary show-more-btn"
                      onClick={() => setIsExpanded((prev) => !prev)}
                    >
                      <i
                        style={{ fontSize: 16 }}
                        className={`bi bi-arrow-${isExpanded ? "up" : "down"
                          }-short`}
                      ></i>
                      <p style={{ margin: 0, fontSize: 12, fontWeight: 600 }}>
                        {isExpanded ? "Show Less" : "Show More"}
                      </p>
                    </button>
                  </Box>
                </>
              ) : (
                <>
                  <Box
                    style={{
                      padding: 16,
                      background: "rgb(255 221 232 / 29%)",
                      borderRadius: "8px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    <Collapse in={isExpanded} collapsedSize="198px">
                      <Box
                        sx={{
                          maxHeight: isExpanded ? "none" : "198px",
                          overflow: "hidden",
                          display: "flex",
                          gap: "8px",
                          flexDirection: "column",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            gap: "8px",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              gap: "8px",
                              alignItems: "center",
                            }}
                          >
                            <i
                              style={{ fontSize: "1.25rem", color: "#f98729" }}
                              className="bi bi-stars"
                            ></i>
                            <h5 className="h5-heading" style={{ margin: 0 }}>
                              AI Overview
                            </h5>
                          </div>

                          {fixNow && (
                            <button
                              className="btn btn-primary"
                              onClick={() => triggerScript(fixNow)}
                              style={{
                                width: "fit-content",
                                background: "rgb(240 72 112)",
                                border: "none",
                                borderRadius: "50px",
                                fontWeight: 600,
                              }}
                            >
                              Fix Now
                            </button>
                          )}
                        </div>
                        {modalOpen && (
                          <NextThinkDevicesPopUp
                            modalOpen={modalOpen}
                            setModalOpen={setModalOpen}
                            NextThinkData={nextThinkResult}
                          />
                        )}
                        <div
                          className={`${!isExpanded ? ( theme.palette.mode === 'dark' ? 'dark-overlay-css' : 'overlay-css' ): ""}`}
                          style={{
                            minHeight: "70px",
                            maxHeight: "fit-content",
                          }}
                        >
                          {typeof generatedData === "string" ? (
                            <>
                              <div style={{ margin: 0 }}>
                                {/* <div
                                  style={{
                                    display: "flex",
                                    gap: "10px",
                                    marginBottom: "8px",
                                  }}
                                >
                                  <p style={{ margin: 0, fontWeight: 600 }}>
                                    {storedPassedData.current}
                                  </p>
                                </div> */}
                                <div style={{ whiteSpace: "pre-line" }}>
                                  {generatedData}
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              {generatedData[generatedData.length - 1]
                                .Internet_answer ? (
                                <div style={{ margin: 0 }}>
                                  {/* <div
                                    style={{
                                      display: "flex",
                                      gap: "10px",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    <p style={{ margin: 0, fontWeight: 600 }}>
                                      {storedPassedData.current}
                                    </p>
                                  </div> */}
                                  <ul>
                                    {generatedData[
                                      generatedData.length - 1
                                    ].Internet_answer.split(/\n/)
                                      .filter((step: any) => step.trim() !== "")
                                      .map((step: any, index: any) => (
                                        <li
                                          style={{ marginBottom: "4px" }}
                                          key={index}
                                        >
                                          {/* {typeof value === 'string'? value: ''} */}
                                          {step.replace(/Step \d+:/, "").trim()}
                                        </li>
                                      ))}
                                  </ul>

                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      flexDirection: "column",
                                      marginTop: "20px",
                                      padding: "16px",
                                      borderTop: "1px solid lightgrey",
                                      gap: "6px",
                                    }}
                                  >
                                    <p
                                      style={{
                                        margin: 0,
                                        fontSize: "12px",
                                        fontWeight: 300,
                                      }}
                                    >
                                      Provide your feedback
                                    </p>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        gap: "10px",
                                      }}
                                    >
                                      <div className="feedback-icn">
                                        <i className="bi bi-hand-thumbs-up" onClick={() => handleGoodFeedback()}></i>
                                      </div>
                                      <div className="feedback-icn">
                                        <i className="bi bi-hand-thumbs-down" onClick={() => handleFeedback()}></i>
                                      </div>
                                    </div>
                                  </div>

                                  {feedbackModal && (
                                  <Feedback
                                  feedbackModal = {feedbackModal}
                                  setFeedbackModal = {setFeedbackModal}
                                  feedbackGreet = {feedbackGreet}
                                  setFeedbackGreet = {setFeedbackGreet}
                                  />
                                  )}

                                  {feedbackGreet && (
                                    <FeedbackGreet
                                    feedbackGreet = {feedbackGreet}
                                    setFeedbackGreet = {setFeedbackGreet}
                                    />
                                  )}


                                </div>
                              ) : (
                                <p
                                  style={{ margin: 0 }}
                                  className="placeholder-glow"
                                >
                                  <span className="placeholder col-12"></span>
                                  <span className="placeholder col-9"></span>

                                  <span className="placeholder col-12"></span>
                                  <span className="placeholder col-4"></span>
                                </p>
                              )}
                            </>
                          )}
                        </div>
                      </Box>
                    </Collapse>

                    <button
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "fit-content",
                        borderRadius: "50px",
                        marginTop: "8px",
                        border: "1px solid #f04870",
                        color: "#f04870",
                      }}
                      className="btn btn-outline-secondary show-more-btn"
                      onClick={() => setIsExpanded((prev) => !prev)}
                    >
                      <i
                        style={{ fontSize: 16 }}
                        className={`bi bi-arrow-${isExpanded ? "up" : "down"
                          }-short`}
                      ></i>
                      <p style={{ margin: 0, fontSize: 12, fontWeight: 600 }}>
                        {isExpanded ? "Show Less" : "Show More"}
                      </p>
                    </button>
                  </Box>
                  {generatedData.map((item: any, index: any) => {
                    if (index === generatedData.length - 1) {
                      return null;
                    }

                    return (
                      <>
                        {item && item.isKb === false ? (
                          <>
                            <div
                              className="card shadow-sm"
                              style={{
                                overflow: "visible",
                                padding: "16px",
                                cursor: "pointer",
                              }}
                            >
                              <div>
                                <p
                                  style={{
                                    margin: 0,
                                    fontSize: "14px",
                                    fontWeight: 500,
                                    color: "var(--header-text-color)",
                                  }}
                                >
                                  {item.title}
                                </p>
                                <p
                                  style={{
                                    fontSize: "14px",
                                    margin: "0px",
                                    color: "#a9a9a9",
                                  }}
                                >
                                  Service Catalog
                                </p>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <Link
                              to="/mn/desktop/kb-article"
                              state={{ passedKbArticle: item }}
                              style={{ textDecoration: "none" }}
                            >
                              <div
                                className="card shadow-sm"
                                style={{
                                  overflow: "visible",
                                  padding: "16px",
                                  cursor: "pointer",
                                }}
                              >
                                <div>
                                  <p
                                    style={{
                                      margin: 0,
                                      fontSize: "16px",
                                      fontWeight: 500,
                                      color: "var(--header-text-color)",
                                    }}
                                  >
                                    {item.short_description}
                                  </p>
                                  <p
                                    style={{
                                      margin: 0,
                                      fontSize: "14px",
                                      fontWeight: 300,
                                      overflow: "hidden",
                                      whiteSpace: "nowrap",
                                      display: "block",
                                      textOverflow: "ellipsis",
                                      color: "var(--header-text-color)",
                                    }}
                                  >
                                    {item.meta_description}
                                  </p>
                                </div>
                              </div>
                            </Link>
                          </>
                        )}
                      </>
                    );
                  })}
                </>
              )}
            </>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <div className="loading-pop-up-icon">
                <img src={appConfig.imagesUrl + "/desktop/loading.gif"}></img>
              </div>
            </div>
          )}
        </div>
      ),
    },
    {
      name: "How to?",
      content: "",
      disabled: true,
    },
    {
      name: "Incidents",
      content: "",
      disabled: true,
    },
    {
      name: "Service Requests",
      content: "",
      disabled: true,
    },
    {
      name: "",
      content: "",
      progress: progress,
      loadingProgressBar: isLoading,
    },
  ];

  return (
    <>
      <div className="row1">
        <div id="back" className="back">
          <BackButton></BackButton>
        </div>
        <div className="logo_bot" style={{ flex: "1 0 auto" }}>
          <div className="bot_image"></div>
        </div>
        <div className="searchBar" style={{ width: "100%" }}>
          <SearchBar searchedValue={searched}          ></SearchBar>
        </div>
      </div>
      <div className="kbListDiv">
        <CustomTabs data={tabData} />
      </div>
    </>
  );
};


const formatText = (text: string) => {
  const regex = /\*\*(.*?)\*\*/g;
  const parts = text.split(regex);
  return parts.map((part, index) =>
    index % 2 === 1 ? (
      <strong style={{ fontWeight: 500 }} key={index}>
        {part}
      </strong>
    ) : (
      part
    )
  );
};
export default KbList;
